import React from 'react';
import { Box, Flex } from '@skin-seoul/design-system';
import ProductCardWishListButton from '../components/WishListButton';
import { useProductCard } from '../ProductCardContext';

type ProductCardContentProps = {
  children: React.ReactNode;
};

export const HorizontalProductCardContent = ({ children }: ProductCardContentProps) => {
  return (
    <Flex position="relative" width="100%" height="100%">
      <Flex position="absolute" w="100%">
        <ProductCardWishListButton backgroundColor="neutral.50" top={2} right={2} />
      </Flex>
      <Flex
        flexDirection="column"
        padding="28px 16px 32px 16px"
        width="100%"
        height="100%"
        minWidth={0}
        gap={2}
        borderRadius="0 8px 8px 0px"
      >
        <>{children}</>
      </Flex>
    </Flex>
  );
};
